<template>
  <v-layout wrap>
    <v-flex xs12>
      <v-list>
        <v-list-item class="my-3">
          <v-list-item-content>
            <v-list-item-subtitle class="caption">申込タイトル</v-list-item-subtitle>
            <v-list-item-title>{{ printTitle }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item class="my-3">
          <v-list-item-content>
            <v-list-item-subtitle class="caption">留学先</v-list-item-subtitle>
            <v-list-item-title>{{ printCountry }}</v-list-item-title>
            <v-list-item-subtitle class="caption"><span class="caption font-weight-bold">都市：</span>{{ printCity }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-subheader>コース</v-subheader>
        <v-divider></v-divider>
        <v-list-item class="my-3" v-for="(item, idx) in getCourseItems" :key="'course_' + idx">
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
            <v-list-item-subtitle class="caption" v-if="item.lesson"><span class="caption font-weight-bold">レッスン内容：</span>{{ item.lesson.size + item.lesson.unit }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-subheader>滞在先</v-subheader>
        <v-divider></v-divider>
        <v-list-item class="my-3" v-for="(item, idx) in getStayItems" :key="'stay_' + idx">
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
            <v-list-item-subtitle class="caption"><span class="caption font-weight-bold">宿泊タイプ：</span>{{ item.type }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'ProgramReaderModalConfirmLayout',
  props: [
    'item'
  ],
  computed: {
    printTitle () {
      return this.$props.item ? this.$props.item.title : ''
    },
    printCountry () {
      return this.$props.item ? this.$props.item.country : ''
    },
    printCity () {
      return this.$props.item ? this.$props.item.city : ''
    },
    getCourseItems () {
      return this.$props.item ? this.$props.item.courses : []
    },
    getStayItems () {
      return this.$props.item ? this.$props.item.stays : []
    }
  }
}
</script>